"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = exports.getDropdownOptionLabel = exports.getDropdownOptionValue = exports.isOptionObject = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const icons_1 = require("../../../icons/icons");
const isOptionObject = (test) => {
    return typeof test !== 'string';
};
exports.isOptionObject = isOptionObject;
const getDropdownOptionValue = (option) => {
    return (0, exports.isOptionObject)(option) ? option.value : option;
};
exports.getDropdownOptionValue = getDropdownOptionValue;
const getDropdownOptionLabel = (option) => {
    return (0, exports.isOptionObject)(option) ? option.label : option;
};
exports.getDropdownOptionLabel = getDropdownOptionLabel;
const Option = ({ option }) => {
    let value, label;
    if (typeof option === 'string') {
        value = label = option;
    }
    else {
        value = option.value;
        label = option.label;
    }
    return react_1.default.createElement("option", { value: value }, label);
};
const Dropdown = ({ value, onChange, options, placeholder, disabled, id, error, hidePlaceholder, className, testing, }) => {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('relative w-full rounded border focus-within:border-blue-4 focus-within:ring focus-within:ring-blue-4/40', error ? 'border-red-5' : 'border-grey-2', { 'bg-slate-2 text-grey-4': disabled }, className), "data-testid": testing && 'dropdown-wrapper' },
        react_1.default.createElement("select", { id: id, value: value, onChange: (e) => onChange(e.currentTarget.value, e), placeholder: placeholder, disabled: disabled, className: (0, classnames_1.default)('w-full min-w-0 appearance-none bg-transparent py-2 pl-3 pr-9 focus:outline-none', {
                'text-grey-4': value === '',
            }) },
            !hidePlaceholder && (react_1.default.createElement("option", { value: "", disabled: true, className: "" }, placeholder || 'Please select')),
            options.map((option) => (react_1.default.createElement(Option, { key: (0, exports.getDropdownOptionValue)(option), option: option })))),
        react_1.default.createElement("div", { className: "pointer-events-none absolute right-0 top-[50%] flex flex-shrink-0 translate-y-[-50%] items-center justify-center px-2" }, icons_1.SVG_ARROW_DOWN)));
};
exports.Dropdown = Dropdown;
